import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbWebServices } from "abweb/service/AbWebServices";
import { DestroyListenerMgr } from "abweb/service/destroyListener/DestroyListenerMgr";
/**
 * Base class for machine objects. Provides basic services, including:
 *
 * <ul>
 *   <li><code>{@link i18n}()</code> convenience function</li>
 *   <li><code>{@link initialize()}</code> function that is tagged as an <code>@action</code> so that it can be used to
 *      modify <code>observable</code> state.
 *   <li><code>{@link destroy()}</code> function</li>
 *   <li>Facility for easy registration of <code>IReactionDisposer</code> objects (things like
 *      <code>autorun</code>, <code>reaction</code>, and so on) that will be automatically cleaned up when the
 *      machine's <code>{@link destroy()}</code> function is called. These are typically defined in the
 *      <code>{@link defineAutomaticBehaviors()}</code> method and registered using
 *      <code>{@link registerDisposer()}</code>.</li>
 * </ul>
 */
export class BaseMachine {
  constructor() {
    // private static readonly BASEMACHINE_LOGGER: ILogger = LogUtils.getLogger(__filename);
    _defineProperty(this, "destroyListenerMgr", new DestroyListenerMgr());
  }
  /**
   * Convenience shorthand function to support typing <code>this.i18n(rbKey, msgKey, ...)</code>
   * instead of <code>AbWebServices.i18nService.getMessage(rbKey, msgKey, ...)</code>
   *
   * @param resourceBundleKey string    the name of the resource bundle to search
   * @param msgKey            string    the name of the message to get
   * @param msgArgs           Object[]  (Optional) arguments to use to fill in the <code>{<i>n</i>}</code>
   *                                      placeholders in the message
   *
   * @return  the message from the bundle, with the arguments filled in
   */
  i18n(resourceBundleKey, msgKey, ...msgArgs) {
    return AbWebServices.i18n.getMessage(resourceBundleKey, msgKey, ...msgArgs);
  }

  /**
   * Cleans up the machine, including calling all registered cleanup functions. Should be called when the machine
   * is no longer in use.   Async to allow teardown to complete async operations (like rpc calls)
   */
  destroy() {
    return this.destroyListenerMgr.destroyAll();
  }

  /**
   * @ignore This should be protected as it is intended for internal use.
   */
  registerDestroyListener(listener) {
    return this.destroyListenerMgr.registerDestroyListener(listener);
  }

  /**
   * @ignore This should be protected as it is intended for internal use.
   */
  registerAsyncDestroyListener(listener) {
    return this.destroyListenerMgr.registerAsyncDestroyListener(listener);
  }

  /**
   * @ignore This should be protected as it is intended for internal use.
   */
  removeAsyncDestroyListener(listener) {
    this.destroyListenerMgr.removeAsyncDestroyListener(listener);
  }
}
//# sourceMappingURL=BaseMachine.js.map
